import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import MDTypography from "../MDTypography";
import LockIcon from "@mui/icons-material/Lock";
import LogoutIcon from "@mui/icons-material/Logout";
import logoImg from "../../assets/images/General/JTC_Logo3x.png";
import { Button, Tooltip } from "@mui/material";
import MKTypography from "../MKTypography";
import GovernmentHeader from "../GovCommon/Header";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import PersonIcon from "@mui/icons-material/Person";
import MaintenanceBanner from "../../pageSections/Maintenance/MaintenanceBanner";
import { useDispatch, useSelector } from "react-redux";
// import "./MUINavBarStyles.css"
import { clearUser } from "../../redux/features/user/userSlice";
import constants from "../../common/constants";
import { Axios_Logout } from "../../api/axiosFunctions";
import CustomMenuItem from "./CustomMenuItem";
import { removeDomainFromEmail } from "../../common/Utility";
import MenuListComposition from "./MenulistComposition";
import MobileViewDrawer from "./MobileViewDrawer";
const settings = ["Profile", "Account", "Dashboard", "Logout"];

const MUINavBar = (props) => {
  const { isAuthenticated } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const handleNavigateToLogin = () => {
    navigate("/login");
  };

  const handleChangePassword = () => {
    navigate("/changepassword", {
      state: {
        email: user.user_name,
        isNoAuthPage: false,
      },
    });
  };

  const handleNavigateToLogout = async () => {
    await Axios_Logout(user.token);
    navigate(constants.prefix_url);
    dispatch(clearUser());
  };

  const loginButton = () => {
    return (
      <Button
        key="Login"
        onClick={() => handleNavigateToLogin()}
        sx={{ my: 2, color: "white", display: "block" }}
      >
        <Grid container alignItems="center" justifyContent="center" spacing={1}>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="center">
              <PersonIcon sx={{ fontSize: 40 }} />
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box display="flex" justifyContent="center">
              <MDTypography variant="h5" color="primary">
                {"Login"}
              </MDTypography>
            </Box>
          </Grid>
        </Grid>
      </Button>
    );
  };

  const toolAppbar = () => {
    return (
      <Toolbar disableGutters>
        <Box
          pb={-8}
          component="img"
          sx={{
            // width: "4.5vw",
            height: 52,
            ml: "-0.1em",
            display: {
              xs: "none",
              md: "flex",
            },
          }}
          mx={1}
          my={0}
          alt="JTC Logo"
          src={logoImg}
          onClick={() => {
            navigate("/home/");
          }}
        />
        {user.token !== "" && user.token !== undefined && isAuthenticated ? (
          <>
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
              <MenuListComposition />
            </Box>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <MobileViewDrawer />
            </Box>
          </>
        ) : (
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "flex" } }}></Box>
        )}
        {/* <Button color="inherit">Login</Button>
         */}
        {!isAuthenticated && loginButton()}
        {isAuthenticated && (
          <CustomMenuItem
            key="NavMenuPersonal#XA1dSa1"
            variation={"personal"}
            MenuTitle={removeDomainFromEmail(user.user_name)}
            MenuSubtitle1={
              (user.first_name || "") + " " + (user.last_name || "")
            }
            MenuSubtitle2={user.email}
            SubMenu={[
              {
                title: "Change Password",
                menuFunction: handleChangePassword,
                icon: <LockIcon />,
                // disabled: true,
              },
              {
                title: "Logout",
                menuFunction: handleNavigateToLogout,
                icon: <LogoutIcon />,
              },
            ]}
            MenuTo={null}
            MenuAppClaims={null}
            usePopper={"mobile"}
          />
        )}
      </Toolbar>
    );
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar my={0} position="relative" color="white">
        <MaintenanceBanner />
        <GovernmentHeader navbar={toolAppbar()} />
      </AppBar>
    </Box>
  );
};
export default MUINavBar;

MUINavBar.defaultProps = {
  isAuthenticated: false,
};
